module.exports = __webpack_public_path__ + "static/media/stock17.bc0edf5d.jpg";